(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('gpfs-batch', {
            parent: 'entity',
            url: '/gpfs-batch?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.gpfsBatch.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gpfs-batch/gpfs-batches.html',
                    controller: 'GpfsBatchController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gpfsBatch');
                    $translatePartialLoader.addPart('gpfsType');
                    $translatePartialLoader.addPart('gpfsStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('gpfs-batch-detail', {
            parent: 'gpfs-batch',
            url: '/gpfs-batch/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.gpfsBatch.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gpfs-batch/gpfs-batch-detail.html',
                    controller: 'GpfsBatchDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gpfsBatch');
                    $translatePartialLoader.addPart('gpfsType');
                    $translatePartialLoader.addPart('gpfsStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GpfsBatch', function($stateParams, GpfsBatch) {
                    return GpfsBatch.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'gpfs-batch',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('gpfs-batch-detail.edit', {
            parent: 'gpfs-batch-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gpfs-batch/gpfs-batch-dialog.html',
                    controller: 'GpfsBatchDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GpfsBatch', function(GpfsBatch) {
                            return GpfsBatch.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gpfs-batch.new', {
            parent: 'gpfs-batch',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gpfs-batch/gpfs-batch-dialog.html',
                    controller: 'GpfsBatchDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                batch: null,
                                gpfsType: null,
                                gpfsStatus: null,
                                batchDate: null,
                                filePath: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('gpfs-batch', null, { reload: 'gpfs-batch' });
                }, function() {
                    $state.go('gpfs-batch');
                });
            }]
        })
        .state('gpfs-batch.edit', {
            parent: 'gpfs-batch',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gpfs-batch/gpfs-batch-dialog.html',
                    controller: 'GpfsBatchDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GpfsBatch', function(GpfsBatch) {
                            return GpfsBatch.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gpfs-batch', null, { reload: 'gpfs-batch' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gpfs-batch.delete', {
            parent: 'gpfs-batch',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gpfs-batch/gpfs-batch-delete-dialog.html',
                    controller: 'GpfsBatchDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GpfsBatch', function(GpfsBatch) {
                            return GpfsBatch.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gpfs-batch', null, { reload: 'gpfs-batch' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
